import { Controller } from "@hotwired/stimulus"
import $ from "jquery"
import "select2"

export default class extends Controller {
  static targets = ["dropdown", "viewReport"]

  connect() {
    this.studentsLoaded = false
    if (!$(this.dropdownTarget).hasClass("select2-hidden-accessible")) {
      $(this.dropdownTarget).select2({
        dropdownParent: $('#selectStudentModal'),
        width: '100%',
        placeholder: "Select Student",
        data: [
          {
            id: '0',
            text: 'Loading students...',
            selected: false,
            disabled: true
          }
        ]
      })
    }

    this.updateLink()
    $(this.dropdownTarget).on('change', this.updateLink.bind(this))
  }

  disconnect() {
    if ($(this.dropdownTarget).hasClass("select2-hidden-accessible")) {
      $(this.dropdownTarget).select2('destroy')
    }
  }

  loadStudents() {
    if (this.studentsLoaded) return;
    fetch("/report_dashboard/students.json")
      .then(response => {
        if (!response.ok) throw new Error("Failed to load students");
        return response.json();
      })
      .then(students => {
        this.dropdownTarget.innerHTML = "";

        if (Array.isArray(students) && students.length > 0) {
          // Add default option
          this.dropdownTarget.innerHTML = '<option value="">All students</option>';

          // Append student options
          students.forEach(student => {
            const option = document.createElement("option");
            option.value = student.id;
            option.textContent = `${student.last_name} ${student.first_name} (${student.email})`;
            option.setAttribute("data-name", student.email);
            this.dropdownTarget.appendChild(option);
          });

          this.initStudentSelect2("Select Student");
        } else {
          const message = "No results found – create a course to view reports";

          // Add disabled message option
          const option = document.createElement("option");
          option.value = "";
          option.textContent = message;
          option.disabled = true;
          option.selected = true;
          this.dropdownTarget.appendChild(option);

          this.initStudentSelect2("Select Student", message);
        }

        this.studentsLoaded = true;
      })
      .catch(() => {
        this.dropdownTarget.innerHTML = '<option value="">Unable to load students</option>';
        this.initStudentSelect2("Unable to load students");
        this.studentsLoaded = false;
      });
  }

  initStudentSelect2(placeholder, noResultsMessage = null) {
    $(this.dropdownTarget).select2({
      dropdownParent: $('#selectStudentModal'),
      width: '100%',
      placeholder: placeholder,
      language: noResultsMessage
        ? { noResults: () => noResultsMessage }
        : {}
    });

    $(this.dropdownTarget).val("").trigger("change");
  }

  updateLink() {
    const dropdown = this.dropdownTarget
    const viewReport = this.viewReportTarget
    const selected = dropdown.options[dropdown.selectedIndex]
    const studentId = selected.value

    if (studentId) {
      const url = `/reports/student_report/${studentId}`
      viewReport.href = url
      viewReport.onclick = (e) => {
        $('#selectStudentModal').modal('hide')
      }
      viewReport.classList.remove('disabled')
    } else {
      viewReport.href = "#"
      viewReport.onclick = function() { return false }
      viewReport.classList.add('disabled')
    }
  }
}
